module.exports = __webpack_public_path__ + "media/images/eca-e9f6a8ab1b467f8752c492b3a3b87dba.png";